// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Link-cls1__d74109700bff83d0931e{/*!*/}.Link-cls2__c4115332004d99d0f81d{cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Link-cls1__d74109700bff83d0931e",
	"cls2": "Link-cls2__c4115332004d99d0f81d Link-cls1__d74109700bff83d0931e"
};
export default ___CSS_LOADER_EXPORT___;
